<template>
    <v-container fluid pa-0>
        <v-card>
        <v-toolbar>
        <v-toolbar-title>  
            Data Export
        </v-toolbar-title>
        <v-spacer />
        <counters></counters>    
    </v-toolbar>
        <v-expansion-panel expand primary >
            <v-expansion-panel-content v-model="exportData">
                <div slot="header" id="exportPanel">Export Data</div>
                <v-card>
                    <v-card-text>
                        <v-btn color="success" @click.stop="exportCsv()" id="exportButton">Export All Effort Grades</v-btn>
                        <v-btn color="success" @click.stop="exportStudentsDerivedDataFields()" id="exportStudentsDerivedDataFields">Export Summary Data</v-btn>
                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content v-model="downloadProgress">
                <div slot="header">Data Export Progress</div>
                <v-card>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-progress-linear
                                :indeterminate="loadingExport"
                                :active="showExport"
                            ></v-progress-linear>
                        </v-layout>
                        <v-layout row wrap>
                            <p v-html="progressReport"></p>
                        </v-layout>
                        <v-layout row wrap>
                            <i>The link to your csv file will appear below when ready</i>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content v-model="exportResults">
                <div slot="header">Data Export Results</div>
                <v-card>
                    <v-card-text>
                        <v-layout row wrap v-model="showFile">
                                <a id="generatedFile" href="#" @click="requestFile()">{{ this.exportedFile }}</a>
                        </v-layout>
                        <v-alert 
                            :value="true" 
                            type="info" 
                            dismissible v-model="showError"
                            outline>
                                {{ this.errorItems[0] }}
                        </v-alert>
                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
        </v-card>
    </v-container>
  
</template>

<script>

import { getAllDataAsCsv,createStudentsDashboardFile, downloadFile, initialize, getDashboardDataCount } from '../utils/effort-tracking-api';
import { getExportProgress, getCsvFile} from '../utils/effort-tracking-api';
import Counters from './Counters'
import { globalStore } from '../main'

export default {
    data() {
        return {
            exportData: false,
            errors: 0,
            errorItems: [],
            timerExport: '',
            progressRetries: 0,
            maxProgressRetries: 6,
            downloadProgress: false,
            exportResults: false,
            loadingExport: false,
            showExport: false,
            exportedFile: '',
            showFile: false,
            progressReport: '',
            showError: false
        }
    },
    components:{
      Counters  
    },
    methods: {
        requestFile() {
            var url = getCsvFile(this.exportedFile);
            downloadFile(url, this.exportedFile);
        },
        exportCsv() {
            this.exportedFile = '';
            this.exportData = false;
            this.downloadProgress = true;
            this.loadingExport = true;
            this.showExport = true;
            var periodId = localStorage.getItem('period-selected');

            getAllDataAsCsv(periodId).then(result => {
                // this.progressRetries = 0;
                if (result) {
                    this.loadingExport = false;
                    this.downloadProgress = true;
                    this.exportResults = false;
                    clearInterval(this.timerExport)
                    this.timerExport = setInterval(this.exportProgressUpdate, 1000);
                }
            });
        },
        exportStudentsDerivedDataFields() {
            this.exportedFile = '';
            this.exportData = false;
            this.downloadProgress = true;
            this.loadingExport = true;
            this.showExport = true;
            var periodId = localStorage.getItem('period-selected');

            getDashboardDataCount(periodId).then(hasData => {
                if (hasData > 0) {
                   createStudentsDashboardFile(periodId).then(result => {
                        if (result) {
                            this.loadingExport = false;
                            this.downloadProgress = true;
                            this.exportResults = false;
                            clearInterval(this.timerExport)
                            this.timerExport = setInterval(this.exportProgressUpdate, 1000);
                        }
                    });   
                } else {
                    this.showError = true;
                    this.errorItems[0] = 'This reporting period has not been completed. Please complete the period first to calculate all effort scores.';
                    this.loadingExport = false;
                    this.downloadProgress = false;
                    this.exportResults = true;
                }
            });
        },
        exportProgressUpdate(){

            getExportProgress().then(progress => {
                console.log('Exporter progress...');
                console.log(progress);
                this.progressReport = progress.status.status;

                if(progress.status.isDone)
                {
                    console.log('is Done...');
                    this.loadingExport = false;
                    this.downloadProgress = false;
                    this.exportResults = true;
                    
                    this.errors= progress.status.errors.length;
                    this.errorItems= progress.status.errors;
                    if (this.errors >0)
                    {
                        this.showFile = false;
                        this.exportedFile = '';
                        this.showError = true;
                    }
                    else
                    {
                        this.showFile = true;
                        this.exportedFile = progress.exportedFile;
                        this.showError = false;
                    }
                    
                    clearInterval(this.timerExport);
                }

                if (progress.IsRunning) {
                    this.loadingExport = false;
                    this.downloadProgress = true;
                    this.exportResults = false;
                }
            });
       
        }
    },

    mounted() {
        initialize().then( x => {
            this.downloadProgress = false;
            this.downloadResults = false;
            this.exportedFile = '';
            getExportProgress().then(progress => {
                if (progress.isRunning) {
                    clearInterval(this.timerExport)
                    this.timerExport = setInterval(this.exportProgressUpdate, 1000);
                    this.exportData = false;
                    this.downloadProgress = true;
                    this.loadingExport = true;
                    this.showExport = true;
                }
            });
        });
    },
    beforeDestroy() {
        this.exportedFile = '';
        clearInterval(this.timerExport);
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ExportData.vue